import React, { useState, useContext, useMemo, useEffect } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledModalCicloAdd } from "../../styled-components/StyledModalCicloAdd.style";
import Swal from "sweetalert2";
import "react-datepicker/dist/react-datepicker.css";
import api from '../../services/api';
import { DynamicInput } from "../../components/DynamicInput";
import { DynamicSelect } from "../../components/DynamicSelect";

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

export const ModalAddProjetoInterno = ({
    isOpen,
    onAfterOpen,
    onRequestClose,
    loadPage,
    projetoInterno,
    peritosList,
    clientes,
    empresaList,
    disciplinasList,
    areasList
}) => {
    const [selectedEmpresa, setselectedEmpresa] = useState(null);
    const [selectedDisciplina, setselectedDisciplina] = useState(null);
    const [selectedArea, setSelectedArea] = useState(null);    
    const [selectedSegurado, setselectedSegurado] = useState(null);
    const [isLoading, setisLoading] = useState(false);
    const [descricao, setDescricao] = useState(null);
    const [cliente, setCliente] = useState(null);
    const [idCliente, setIdCliente] = useState(null);
    const [idEmpresa, setIdEmpresa] = useState(null);
    const [idDisciplina, setIdDisciplina] = useState(null);
    const [idArea, setIdArea] = useState(null);
    const [idLider, seIdLider] = useState(null);
    const [selectedProfissional, setProfissional] = useState(null);
    const [titulo, setTitulo] = useState("");

    useEffect(() => {
        // Sempre que abrir o modal, limpar
        if (!isOpen || !projetoInterno?.idProjetoInterno) {
            setTitulo("");
            setDescricao("");
            setCliente(null);
            setIdCliente(null);
            setIdEmpresa(null);
            seIdLider(null);
            setIdDisciplina(null);
            setIdArea(null);
            setselectedEmpresa(null);
            setselectedDisciplina(null);
            setSelectedArea(null);
            setselectedSegurado(null);
            setProfissional(null);
        }

        // Se for edição, preencher os campos
        if (isOpen && projetoInterno?.idProjetoInterno) {
            setDescricao(projetoInterno.descricao);
            setTitulo(projetoInterno.titulo);
            getProfissional(null, projetoInterno.idLider);
            getCliente(null, projetoInterno.idCliente);
            getEmpresa(null, projetoInterno.idEmpresa);
            getDisciplinas(null, projetoInterno.idDisciplina);
            getAreas(null, projetoInterno.idArea);
        }
    }, [isOpen, projetoInterno]);

    const style = {
        content: {
            top: '45%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '50%',
            overflowY: 'auto',
            minHeight: 'calc(0vh - 250px)',
            maxHeight: 'calc(100vh - 250px)',
        },
        overlay: {
            zIndex: 9999
        }
    };

    const handleDescricaoChange = (descricao) => {
        setDescricao(descricao);
    }

    const registrationSuccess = (text = "Cadastro realizado com sucesso") => {
        Swal.fire({
            title: "Sucesso",
            text: text,
            icon: "success",
            timer: 2500,
            showConfirmButton: false,
        });
    };

    const registrationFailure = (text = "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    };

    const save = async () => {
        let campos = [];
        
        if (!idLider) campos.push("Líder");
        if (!titulo) campos.push("Título");
        if (!idEmpresa) campos.push("Empresa");
        if (!idArea) campos.push("Área");
        if (!idDisciplina) campos.push("Disciplina");

        if (campos.length > 0) {
            const camposFaltantes = campos.join(', ');
            registrationFailure(`Verifique os campos obrigatórios: ${camposFaltantes}`);
            return;
        }

        var payload = {
            idProjetoInterno: projetoInterno?.idProjetoInterno,
            titulo: titulo,
            descricao: descricao,
            idCliente: idCliente,
            idEmpresa: idEmpresa,
            idLider: idLider,
            idDisciplina: idDisciplina,
            idArea: idArea,
        };
        try {
            await api.patch('ProjetosInternos', payload);
            setTitulo("");
            setDescricao("");
            setCliente(null);
            setIdEmpresa(null);
            seIdLider(null);
            setIdDisciplina(null);
            setIdArea(null);
            await loadPage()
            onRequestClose()
            var text = projetoInterno?.idProjetoInterno ? "Projeto Interno atualizado com sucesso!" : "Projeto Interno cadastrado com sucesso!"
            registrationSuccess(text)
        } catch (error) {
            registrationFailure("Erro ao salvar Projeto Interno. Tente novamente.");
        }
    }

    const getCliente = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setCliente(null);
            setIdCliente(null);
            return;
        }

        var clienteResult = clientes.filter(function (o) {
            return o.idCliente == value;
        });

        var cliente = clienteResult[0].nomeFantasia;
        var idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };

    const getEmpresa = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setselectedEmpresa(null);
            setIdEmpresa(null);
            return;
        }

        var statusResult = empresaList.filter(function (o) {
            return o.idEmpresa == value;
        });

        var status = statusResult[0].description;
        var idEmpresa = statusResult[0].idEmpresa;
        setselectedEmpresa(status);
        setIdEmpresa(idEmpresa);
    };

    const getProfissional = (currentValue, value) => {
        if (value === null || value === "") {
            setProfissional(null);
            seIdLider(null);
            return;
        }

        var profissionalResult = peritosList.filter(function (o) {
            return o.idUsuario == value;
        });
        var profissional = profissionalResult[0].nome;
        var idProfissional = profissionalResult[0].idUsuario;
        setProfissional(profissional);
        seIdLider(idProfissional);
    }

    const getDisciplinas = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setselectedDisciplina(null);
            setIdDisciplina(null);
            return;
        }

        var disciplinaResult = disciplinasList.filter(function (o) {
            return o.idDisciplina == value;
        });

        var tituloDisciplina = disciplinaResult[0].titulo;
        var idDisciplina = disciplinaResult[0].idDisciplina;
        setselectedDisciplina(tituloDisciplina);
        setIdDisciplina(idDisciplina);
    };

    const getAreas = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setSelectedArea(null);
            setIdArea(null);
            return;
        }

        var areaResult = areasList.filter(function (o) {
            return o.idArea == value;
        });

        var tituloDisciplina = areaResult[0].description;
        var idArea = areaResult[0].idArea;
        setSelectedArea(tituloDisciplina);
        setIdArea(idArea);
    };

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Projeto Interno Add"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
        >
            <StyledModalCicloAdd>
                <StyledForm>
                    <p className="modal-close" onClick={onRequestClose}>X</p>
                </StyledForm>
                <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group mb-0">
                                <p className="modal-title">
                                    {
                                        projetoInterno?.idProjetoInterno ? "Editar " : "Adicionar "
                                    } 
                                    Projeto Interno
                                </p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    {isLoading ? (
                        <div className="text-center">
                            <div className="align-items-center">
                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <StyledForm>
                                <div className='row justify-align-content-around'>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                        <span style={{fontSize: '14px'}}>Líder <span style={{ color: 'red' }}>*</span></span>
                                        <DynamicSelect 
                                            placeholder={''}
                                            valuetext={selectedProfissional}
                                            label={<>Selecione o Líder</>}
                                            name={'idLider'}
                                            options={peritosList}
                                            keyValue={'idUsuario'}
                                            keyLabel={'nome'}
                                            paramMethod={getProfissional}
                                            clearOption={true}
                                        />
                                    </div>
                                </div>
                                <div className='row justify-align-content-around mt-1'>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                        <span style={{fontSize: '14px'}}>Área <span style={{ color: 'red' }}>*</span></span>
                                        <DynamicSelect 
                                            placeholder={''}
                                            valuetext={selectedArea}
                                            label={<>Selecione uma Área</>}
                                            name={'idArea'}
                                            options={areasList} //.filter(f => f.idArea != 9 && f.idArea != 10 && f.idArea != 11 && f.idArea != 13 && f.idArea != 14)
                                            keyValue={'idArea'}
                                            keyLabel={'description'}
                                            paramMethod={getAreas}
                                            clearOption={true}
                                        />
                                    </div>
                                </div>
                                <div className='row justify-align-content-around mt-1'>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                        <span style={{fontSize: '14px'}}>Disciplina <span style={{ color: 'red' }}>*</span></span>
                                        <DynamicSelect 
                                            placeholder={''}
                                            valuetext={selectedDisciplina}
                                            label={<>Selecione uma Disciplina</>}
                                            name={'idDisciplina'}
                                            options={disciplinasList} //.filter(f => f.idArea != 9 && f.idArea != 10 && f.idArea != 11 && f.idArea != 13 && f.idArea != 14)
                                            keyValue={'idDisciplina'}
                                            keyLabel={'titulo'}
                                            paramMethod={getDisciplinas}
                                            clearOption={true}
                                        />
                                    </div>
                                </div>
                                <div className='row justify-align-content-around mt-1'>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                        <span style={{fontSize: '14px'}}>Empresa <span style={{ color: 'red' }}>*</span></span>
                                        <DynamicSelect 
                                            placeholder={''}
                                            valuetext={selectedEmpresa}
                                            label={<>Selecione a Empresa</>}
                                            name={'idEmpresa'}
                                            options={empresaList}
                                            keyValue={'idEmpresa'}
                                            keyLabel={'description'}
                                            paramMethod={getEmpresa}
                                            clearOption={true}
                                        />
                                    </div>
                                </div>
                                <div className='row justify-align-content-around mt-1'>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                        <span style={{fontSize: '14px'}}>Cliente</span>
                                        <DynamicSelect
                                            valuetext={cliente}
                                            label={<>Selecione o Cliente</>}
                                            name={'idCliente'}
                                            options={clientes}
                                            keyValue={'idCliente'}
                                            keyLabel={'cliente'}
                                            clearOption={true}
                                            paramMethod={getCliente}
                                        />
                                    </div>
                                </div>
                                <div className='row justify-align-content-around mt-3'>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                        <DynamicInput
                                            type={"text"}
                                            placeholder={"Digite aqui"}
                                            label={<>Título <span style={{ color: 'red' }}>*</span></>}
                                            name={"Título"}
                                            value={titulo}
                                            paramMethod={(value) => setTitulo(value)}
                                        />
                                    </div>
                                </div>
                                <div className='row justify-align-content-around mt-3'>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                        <textarea
                                            rows="3"
                                            className="input-form-list"
                                            style={{ width: '100%' }}
                                            name="Descrição"
                                            placeholder="Descrição"
                                            key={descricao}
                                            defaultValue={descricao}
                                            onBlur={(event) => handleDescricaoChange(event.target.value)} />
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center mt-1 mb-0'>
                                    <div className="col-sm-3 col-md-3 col-lg-3">
                                        <button type="button" className='default-button-red' onClick={() => save()}>Salvar</button>
                                    </div>
                                </div>
                            </StyledForm>
                        </div>
                    )}
                </StyledForm>
            </StyledModalCicloAdd>
        </Modal>
    );
};